export default __webpack_public_path__ + "static/media/defaultUserprofile.b2c01399.png";